import {
    Model
} from '@vuex-orm/core'

import Attendance from './Attendance'

export default class Coordinate extends Model {

    static entity = 'coordinates'

    static fields() {
        return {
            id: this.attr(null),
            attendance_id: this.attr(null),
            attendance: this.belongsTo(Attendance, 'id'),
            latitude: this.attr(''),
            longitude: this.attr(''),
            low_power: this.attr(''),
            bluetooth: this.attr(''),
            extra: this.attr(null),
            created_at: this.attr(null)
        }
    }
}